module.exports = __webpack_public_path__ + "static/media/salesIco.a98d0992.svg";